<template>
  <div v-if="designerStore.mobileModal">
    <div
class="tw-fixed tw-inset-0 tw-bg-black/50 tw-flex tw-items-center tw-justify-center"
style="z-index: 5000;"
>
      <div class="tw-bg-white tw-rounded-2xl tw-p-6 tw-shadow-2xl tw-w-full tw-max-w-md tw-border tw-border-gray-200 tw-m-2.5">
        <div class="tw-mb-4">
          <h2 class="tw-text-xl tw-font-semibold tw-flex tw-items-center tw-gap-2">
            Your Design
          </h2>

          <ImageLayering />
        </div>

        <div class="tw-flex tw-justify-end">
          <button
              class="tw-mt-4 tw-px-4 tw-py-2 tw-rounded-lg tw-bg-gray-100 hover:tw-bg-gray-200 tw-text-gray-800 tw-border tw-border-gray-300 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-indigo-500"
              @click="designerStore.mobileModal = false"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddToCart from "@/components/backend/pages/designer/components/List/AddToCart.vue";
import ImageLayering from "@/components/backend/pages/designer/components/List/ImageLayering.vue";
import {useDesignerStore} from '@/stores/DesignerStore';

export default {
  name: "MobileModal",
  components: {
    ImageLayering
  },
  setup() {
    const designerStore = useDesignerStore();
    return {designerStore};
  },
};
</script>

<style scoped>
.mobile-toolbar .add-to-cart {
  margin-top: 0;
  padding: 12px 20px;
}

.mobile-toolbar .add-to-cart .default:before,
.mobile-toolbar .add-to-cart .default:after {
  top: 16px;
}

.view-design-btn {
  --color: #fff;
  --icon: var(--color);
  --cart: #fff;
  --dots: #fff;
  --background: #007bff;
  --shadow: rgba(0, 9, 61, 0.16);
  cursor: pointer;
  position: relative;
  outline: none;
  margin-left: 5px;
  border: none;
  font-size: 16px;
  border-radius: 22px;
  padding: 12px 20px;
  font-weight: 500;
  line-height: 20px;
  box-shadow: 0 var(--s-y, 4px) var(--s-b, 12px) var(--shadow);
  color: var(--color);
  background: var(--background);
  transition: transform 0.3s, box-shadow 0.3s;
}
.view-design-btn .default {
  padding-left: 16px;
  position: relative;
  opacity: var(--o, 1);
  transform: scale(var(--s, 1));
  transition: transform 0.3s, opacity 0.3s;
  transition-delay: var(--d, 0.3s);
}

/* Hide toolbar on larger screens */
@media (min-width: 769px) {
  .mobile-toolbar {
    display: none !important;
  }
}

/* Mobile toolbar styles */
.mobile-toolbar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  background-color: #ffffff;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #ddd;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100000;
}

/* Price styling */
.price {
  font-size: 15px;
  font-weight: bold;
  width: 20%;
}

/* Button styles */
.btn {
  padding: 10px 16px;
  font-size: 14px;
  border: none;
  cursor: pointer;
  border-radius: 20px;
  margin-left: 8px;
}

.add-to-cart {
  background-color: #28a745;
  color: white;
}

.view-design {
  background-color: #007bff;
  color: white;
}

/* Button hover effects */
.btn:hover {
  opacity: 0.8;
}
</style>
